//import from react library
import * as React from "react";

//imports from mui library
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PaymentIcon from '@mui/icons-material/Payment';
import QrCodeIcon from '@mui/icons-material/QrCode';
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Button, Grid, IconButton, Modal, Tooltip } from "@mui/material";
import DatePickerFieldNew from "../../../common/components/FormFields/DatePickerFieldNew";
//imports from the Common Components
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import InputField from "../../../common/components/FormFields/InputField";

import ConfirmationModal from "../../../common/components/ConfirmationModal";

//importing the styles applied to the modal.
import { ModalStyle } from "./BillInfoModalStyle";

//imports from react hook form
import { useFieldArray, useForm } from "react-hook-form";

//imports from the yup library
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

//importing the services that are going to be used.
import {
  fetchConcessionAuthority,
  fetchUpiTypes,
} from "../../../commonServices/miscellaneousServices/MiscServices";
import { getBankList, getBillingAdvanceDetails, getCheckStatus, getPaymentMode, getVerifyCard } from "../../services/BillingServices";

import CommonButton from "../../../common/components/Buttons/CommonButton";

import { errorAlert, successAlert, warningAlert } from "../../../common/components/Toasts/CustomToasts";
import AdvanceConsumeDetails from "./AdvanceConsumeDetails";

let renderCount = 0;
const ModalStyleTransactionType = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  borderRadius: 4,
  border: "1px solid gray",
  boxShadow: 20,
  // overflowY: "scroll",

  p: 2,
};
export default function BillInformationModal(props) {
  const Actions = [
    {
      id: 0,
      action: "Save",
      isAction: false,
    },
  ];

  console.log("propspropspropspropspropsprops", props);


  //function to render the non-tabular buttons
  function renderNonTabularButtons() {
    const buttonDisplayOutput = Actions.map((singleActionObj) => {
      if (
        singleActionObj.isAction === false &&
        singleActionObj.action === "Save"
      ) {
        return (
          <>
            <CommonButton
              label="Cancel"
              className="border border-customRed text-customRed"
              onClick={() => {
                props.closePaymentModal();
                renderCount = 0;
              }}
            />
            <CommonButton
              label="Save"
              className="bg-customGreen text-white"
              onClick={() => {
                let paymentDateMatchingResult = validatePaymentDate();
                console.log("paymentDateMatchingResultpaymentDateMatchingResult", paymentDateMatchingResult);

                if (paymentDateMatchingResult === true) {
                  postOpdBillWithFieldArray();
                } else if (paymentDateMatchingResult === false) {
                  errorAlert("Please enter today's date");
                }
              }}
            />
          </>
        );
      } else {
        return null;
      }
    });

    return buttonDisplayOutput;
  }

  //yup validation schema that is going to be applied on the field array.
  const paymentSchema = yup.object().shape({
    paymentCart: yup.array().of(
      yup.object().shape({
        // validation schema for paymentMode dropdown
        paymentMode: yup
          .object()
          .nullable()
          .shape({
            value: yup.string().required(" "),
            label: yup.string().required(" "),
          })
          .required(" "),

        //validation schema for amount input field
        amount: yup.number().min(0).required("Required"),

        //validation schema for referenceNumber input field
        referenceNumber: yup.string().when("paymentMode", (paymentMode) => {
          let paymentModeName;

          if (paymentMode) {
            paymentModeName = paymentMode.label;
          }

          if (paymentModeName === "CHEQUE") {
            return yup
              .string()
              .required("Reference Number Required")
              .max(30, "Only 6 Digits allowed");
          }

          if (
            paymentModeName === "DEBIT CARD" ||
            paymentModeName === "CREDIT CARD"
          ) {
            return yup
              .string()
              .required("Reference Number Required")
              .max(30, "Only 4 Digits allowed");
          }

          if (
            paymentModeName === "UPI" ||
            paymentModeName === "ECS" ||
            paymentModeName === "ONLINE"
          ) {
            return yup
              .string()
              .required("Reference Number Required")
              .matches(/^[0-9a-zA-Z]+$/, "Must be alphanumeric.")
              .max(30);
          }

          if (paymentModeName === "CASH") {
            return yup.string().notRequired();
          }
        }),

        upiOption: yup
          .object()
          .nullable()
          .shape({
            value: yup.string(),
            label: yup.string(),
          })
          .when("paymentMode", (paymentMode) => {
            let paymentModeName;

            if (paymentMode) {
              paymentModeName = paymentMode.label;
            }

            if (paymentModeName === "UPI") {
              return yup
                .object()
                .required(" ")
                .nullable()
                .shape({
                  value: yup.string().required(" "),
                  label: yup.string().required(" "),
                });
            } else {
              return yup
                .object()
                .notRequired()
                .nullable()
                .shape({
                  value: yup.string().notRequired(),
                  label: yup.string().notRequired(),
                })
                .notRequired();
            }
          }),

        bankName: yup
          .object()
          .nullable()
          .shape({
            value: yup.string(),
            label: yup.string(),
          })
          .when("paymentMode", (paymentMode) => {
            let paymentModeName;

            if (paymentMode) {
              paymentModeName = paymentMode.label;
            }

            if (
              paymentModeName === "CREDIT CARD" ||
              paymentModeName === "CHEQUE" ||
              paymentModeName === "ECS" ||
              paymentModeName === "DEBIT CARD" ||
              paymentModeName === "ONLINE"
            ) {
              return yup
                .object()
                .required(" ")
                .nullable()
                .shape({
                  value: yup.string().required(" "),
                  label: yup.string().required(" "),
                });
            } else {
              return yup
                .object()
                .notRequired()
                .nullable()
                .shape({
                  value: yup.string().notRequired(),
                  label: yup.string().notRequired(),
                })
                .notRequired();
            }
          }),
      }),
    ),

    concessionAuthority: yup
      .object()
      .nullable()
      .shape({
        value: yup.string(),
        label: yup.string(),
      })
      .when(() => {
        //apply the validation ; if and only if the concessionAuthority dropdown is visible.
        if (authorityDropdown === true) {
          return yup
            .object()
            .required(" ")
            .nullable()
            .shape({
              value: yup.string().required(" "),
              label: yup.string().required(" "),
            })
            .required(" ");
        } else if (authorityDropdown === false) {
          return yup
            .object()
            .notRequired()
            .nullable()
            .shape({
              value: yup.string().notRequired(),
              label: yup.string().notRequired(),
            })
            .notRequired();
        }
      }),

    consumeAmount: yup.number().when((consumeAmount) => {
      if (consumeAdvanceFlag === true) {
        return yup.number().min(0.1);
      } else if (consumeAdvanceFlag === false) {
        return yup.string().notRequired();
      }
    }),
    status: yup.string().notRequired(),
  });

  //getting the today's date object into the variable called "today"
  let today = new Date();

  const defaultValues = {
    paymentCart: [
      {
        paymentMode: null,
        amount: "",
        referenceNumber: "",
        bankName: null,
        paymentDate: today,
        upiOption: null,
        payment: null,
        status: "pending",
      },
    ],
    concessionAuthority: null,
    consumeAmount: "",
    consumeAdvance: false,
    remarks: "",
  };

  //destructuring the methods and giving them the same name , as they have in the useForm() hook
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    register,
    trigger,
    clearErrors,
    resetField,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(paymentSchema),
    defaultValues,
  });

  let getConsumeAmount = watch("consumeAmount")

  //declaring the field array called "paymentCart"
  const { fields, append, remove, update } = useFieldArray({
    name: "paymentCart",
    control,
  });

  let cartArr = watch("paymentCart");


  //state variable to store the bank list options
  const [bankList, setBankList] = React.useState([]);

  const [upiOptionsList, setUpiOptionsList] = React.useState([]);

  //state variable to store the options of payment mode
  const [paymentModeList, setPaymentModeList] = React.useState([]);

  //state variable to open or close the confirmation for field arrays being displayed
  const [confirmationOpen, setConfirmationOpen] = React.useState(false);
  const [openAdvanceConsumeModal, setOpenAdvanceConsumeModal] = React.useState(false)

  //state variable to open or close the confirmation for field arrays not being displayed
  const [openConfirmationForNoFields, setOpenConfirmationForNoFields] =
    React.useState(false);

  //state variable to hold the netPayableAmount's value
  const [netPayableAmountVal, setNetPayableAmountVal] = React.useState(0);

  //state variable to display the consume amount error message
  const [consumeErrorMsgOne, setConsumeErrorMsgOne] = React.useState("");

  const [consumeErrorMsgTwo, setConsumeErrorMsgTwo] = React.useState("");

  const [netPayErrorMessage, setNetPayErrorMessage] = React.useState("");

  //state variable to store the advance of the patient
  const [advance, setAdvance] = React.useState(null);

  //state variable to hold the state of consume advance checkbox
  const [consumeAdvanceFlag, setConsumedAdvanceFlag] = React.useState(false);

  //state variable to set the error on payment mode dropdown when CASH option is selected more than once.
  const [customCashError, setCustomCashError] = React.useState(false);

  const [showAddIcon, setShowAddIcon] = React.useState(false);

  //state variable to populate the concessionAuthority dropdown.
  const [concessionAuthorityArray, setConcessionAuthorityArray] =
    React.useState([]);

  //state variable to open the bill settlement confirmation modal
  const [billSettlementConfirmation, setBillSettlementConfirmation] =
    React.useState(false);

  //state variable to display or hide the authority dropdown
  const [authorityDropdown, setAuthorityDropdown] = React.useState(false);
  const [isVerified, setIsVerified] = React.useState(false)
  const [isCheckStauts, setCheckStatus] = React.useState(false)
  const [parseData, setParseData] = React.useState(null)

  const [displayCreditAuthorityLabel, setDisplayCreditAuthorityLabel] =
    React.useState(true);

  const [openStartTransactionModal, setOpenStartTransactionModal] = React.useState(false)
  const [transactionType, setTransactionType] = React.useState("")
  const [selectedIndex, setSelectedIndex] = React.useState(null)
  //trace the paymentCart array

  console.log("payment usefield array is", cartArr);

  //Call the services to patch the drop down values
  let payments = "";
  // React.useEffect(() => {
  //   if (cartArr.length > 0) {
  //     for (let paymentObj of cartArr) {
  //       if (paymentObj?.paymentMode?.label) {
  //         payments = payments + paymentObj?.paymentMode?.label;
  //       }
  //     }
  //   }
  //   let newPaymentArr = [];
  //   for (let payment of paymentModeList) {
  //     if (
  //       !payments
  //         ?.toLocaleLowerCase()
  //         .includes(payment?.label?.toLocaleLowerCase())
  //     ) {
  //       newPaymentArr.push(payment);
  //       setPaymentModeList(newPaymentArr);
  //     }
  //   }
  // }, [cartArr]);

  const computedNetPayable = React.useMemo(() => {
    const bill = Number(props.getValues("netPayableAmount") || 0);
    const consume = Number(getValues("consumeAmount") || 0);

    return Math.max(bill - consume, 0);
  }, [
    props.getValues("netPayableAmount"),
    watch("consumeAmount"),
  ]);

  const paymentAmountsWatcher = cartArr
    ?.map((item) => ({
      amount: item?.amount,
      paymentMode: item?.paymentMode?.label,
    }))
    ?.map((item) => JSON.stringify(item))
    ?.join("|");

  React.useEffect(() => {
    if (props?.selectedPatient?.patientCategory !== "Self") {
      const totalSumVal = Number(
        calculateFieldAmountSum() || 0
      );
      const effectiveNetPayable = Number(
        computedNetPayable || 0
      );
      const outstanding = Number(
        Math.max(
          effectiveNetPayable - totalSumVal,
          0
        ).toFixed(2)
      );
      console.log(
        "Authority Effect",
        {
          totalSumVal,
          effectiveNetPayable,
          outstanding,
          paymentAmountsWatcher,
        }
      );
      // Show authority dropdown if payment incomplete
      if (outstanding > 0) {
        setAuthorityDropdown(true);
      } else {
        setAuthorityDropdown(false);
        // reset dropdown
        setValue("concessionAuthority", null, {
          shouldValidate: false,
          shouldDirty: false,
        });
        clearErrors("concessionAuthority");
      }
    }
  }, [
    paymentAmountsWatcher,
    computedNetPayable,
    consumeAdvanceFlag,
    getConsumeAmount,
  ]);

  console.log("cartArr321", cartArr);


  React.useEffect(() => {

    getBillingAdvanceDetails(props?.selectedPatient?.patientId)
      .then((response) => response?.data)
      .then((res) => {
        console.log("getBillingAdvanceDetails", res);
        props?.setConsumeAdvanceData(res?.result?.map((item) => ({
          ...item, consumeAmount: 0
        })))



      }).catch((err) => {
        errorAlert(err?.message)
      })
  }, [])
  React.useEffect(() => {
    fetchUpiTypes().then((response) => {
      setUpiOptionsList(response.data.result);
    });

    setValue("consumeAdvance", false);
    setConsumedAdvanceFlag(false);

    //calling the api to populate the bank list dropdown
    getBankList().then((response) => {
      setBankList(response.data.result);
    });

    //calling the api to populate the paymentmode list dropdown
    getPaymentMode().then((response) => {
      setPaymentModeList(response.data.result);
      //set the value of the first field's dropdown field to "CASH"
      setValue(`paymentCart.[0].paymentMode`, response.data.result[1]);
    });

    //Calling the api to polulate the Concession Authority list dropdown
    fetchConcessionAuthority()
      .then((response) => response.data)
      .then((res) => {
        setConcessionAuthorityArray(res.result);
      });

    //storing the patient's advance in the state variable called "advance"
    if (props.selectedPatient.patientAdvance === null) {
      setAdvance(0);
    } else if (props.selectedPatient.patientAdvance !== null) {
      setAdvance(props.selectedPatient.patientAdvance);
    }

    //store the patient's advance balance into the variable "tempAdvance"
    let tempAdvance = props.selectedPatient.patientAdvance;

    //if the available patient advance is null ; then set the props.getValues("netPayableAmount") value in the
    //state variable netPayableAmountVal.
    if (tempAdvance === null) {
      setNetPayableAmountVal(props.getValues("netPayableAmount"));

      let netPayVal = props.getValues("netPayableAmount");

      //if companyId is greater than 0
      //set the value of first field as 0
      //else set the value of first field as netPayVal.
      if (props.companyId > 1) {
        setValue(`paymentCart.[0].amount`, 0);
      } else if (props.companyId === 0) {
        setValue(`paymentCart.[0].amount`, netPayVal);
      }
    }

    if (tempAdvance !== null) {
      //if the available advance balance is 0 ; then set the value of netPayableAmountVal state variable.
      let netPayVal = props.getValues("netPayableAmount");

      setNetPayableAmountVal(netPayVal);
      //if companyId is greater than 0
      //set the value of first field as 0
      //else set the value of first field as netPayVal.
      if (props.companyId > 1) {
        setValue(`paymentCart.[0].amount`, 0);
      } else if (props.companyId === 0) {
        setValue(`paymentCart.[0].amount`, netPayVal);
      }
    }
  }, []);

  //When the consumeAdvance checkbox is unticked ; then the following below things should happen.
  React.useEffect(() => {
    if (consumeAdvanceFlag === false || consumeAdvanceFlag === "false") {

      // Total bill amount
      let netPayVal = Number(props.getValues("netPayableAmount"));

      setNetPayableAmountVal(netPayVal);

      // remove extra rows
      remove();

      // get consume amount
      let consumeAmt = Number(getValues("consumeAmount")) || 0;

      // calculate remaining payable
      let remainingAmount = netPayVal - consumeAmt;

      if (remainingAmount < 0) {
        remainingAmount = 0;
      }

      // set amount properly
      if (props.companyId > 1) {
        setValue(`paymentCart.[0].amount`, 0);
      } else if (props.companyId === 0) {
        setValue(`paymentCart.[0].amount`, remainingAmount);
      }

      // set payment mode
      setValue(`paymentCart.[0].paymentMode`, {
        id: 4,
        label: "CASH",
        value: "CASH",
      });

      clearErrors("consumeAmount");
    }
  }, [consumeAdvanceFlag]);
  // Whenever there is increment in the field array ; at that time we need to handle the
  // display of ConcessionAuthority dropdown.
  React.useEffect(() => {
    // whenever the field is appended ; the remaining amount is populated in the next field's Amount input field ;
    // so that sum of all the amount input fields becomes equal to netPayableAmountVal.
    // Then at that time we need to handle the display of concessionAuthority dropdown.
    //when companyId is 0 ; at that time we do not set the first field's Amount InputField to 0.
    if (cartArr.length >= 1 && props.companyId === 0) {
      // function to control the display of the concessionAuthority dropdown

      let source = "if block of [cartArr] useEffect ";
      // displayConcessionAuthorityDropdown(source);
    }
  }, [cartArr]);

  //function to return the date in yyyy-MM-DD format
  function getRequiredDateVal(inputDateVal) {
    let requiredDate = null;

    let objectDate = new Date(inputDateVal);

    let day = String(objectDate.getDate());

    if (day.length === 1) {
      day = `0${day}`;
    }

    let month = objectDate.getMonth();

    month = month + 1;

    month = String(month);

    if (month.length === 1) {
      month = `0${month}`;
    }

    let year = objectDate.getFullYear();

    requiredDate = `${year}-${month}-${day}`;

    if (requiredDate.length === 10) {
      return requiredDate;
    } else {
      return null;
    }
  }

  //function to verify whether the payment date is today's date or not.
  function validatePaymentDate() {
    let todaysDate = new Date();

    todaysDate = getRequiredDateVal(todaysDate);

    let isDateMatchingWithTodaysDate = true;

    for (let paymentObj of cartArr) {
      if (paymentObj.hasOwnProperty("paymentDate") === true) {
        let paymentDateVal = paymentObj.paymentDate;
        paymentDateVal = getRequiredDateVal(paymentDateVal);

        if (todaysDate !== paymentDateVal) {
          isDateMatchingWithTodaysDate = false;
          break;
        }
      }
    }

    return isDateMatchingWithTodaysDate;
  }

  //function to calculate the sum of all the amounts typed in the amount input field of useFieldArray
  function calculateFieldAmountSum() {
    let totalAmount = 0;

    //Calculate the sum of all the paid amounts from various payment modes and store it in the variable totalAmount.
    for (let cartObj of cartArr) {
      if (cartArr.length > 1) {
        if (cartObj && cartObj.amount) {
          totalAmount = Number(totalAmount) + Number(cartObj.amount);
        }
      } else if (cartArr.length === 1 && cartObj.amount) {
        totalAmount = Number(cartObj.amount);
      }
    }

    return totalAmount;
  }

  //function to close advance consume modal
  const handleCloseAdavnceConsumeModal = () => {
    setOpenAdvanceConsumeModal(false)
    // setValue("consumeAdvance",false)
  }

  //function to close the confirmation modal
  const confirmationHandleClose = () => {
    if (confirmationOpen === true) {
      setConfirmationOpen(false);
    }
  };

  //function to close the confirmation modal
  const closeConfirmationForNoFields = () => {
    if (openConfirmationForNoFields === true) {
      setOpenConfirmationForNoFields(false);
    }
  };

  //function to close the bill settlement confirmation modal
  const billSettlementConfirmationClose = () => {
    if (billSettlementConfirmation === true) {
      setBillSettlementConfirmation(false);
    }
  };

  //function that is called after clicking the submit button of the payment info modal
  function onSubmitDataHandler(data) {
    props.setOpenBackdrop(true);

    //close the confirmation modal
    confirmationHandleClose();

    // //close the bill information modal
    props.setOpen(false);

    let paymentInfoList = [];

    let paymentInfoListObj = {};

    let isAdvanceConsume = getValues("consumeAdvance");
    let consumeAdvance = getValues("consumeAmount");

    paymentInfoListObj.isAdvanceConsume = isAdvanceConsume;
    paymentInfoListObj.consumeAdvance = consumeAdvance;
    paymentInfoListObj.paymentInfoList = paymentInfoList;
    paymentInfoListObj.remarks = data.remarks;

    let paymentCart = data.paymentCart;

    let paidAmountFinal = 0;
    let a = 0;

    for (let paymentObj of paymentCart) {
      a = paymentObj.amount;
      paidAmountFinal = parseInt(paidAmountFinal) + parseInt(a);
    }

    for (let formObj of paymentCart) {
      let obj = {
        amount: 0,
        bankId: 0,
        paymentDate: "",
        paymentType: {
          id: 0,
          label: "",
          value: "",
        },
        referenceNumber: "",
        upiTypeId: null,
      };

      obj.amount = formObj.amount;
      obj.paymentType = formObj.paymentMode;

      if (formObj.hasOwnProperty("referenceNumber")) {
        obj.referenceNumber = formObj.referenceNumber;
      }

      if (formObj.hasOwnProperty("bankName")) {
        if (formObj.bankName) {
          obj.bankId = formObj.bankName.id;
        }
      }

      if (formObj.hasOwnProperty("paymentDate")) {
        obj.paymentDate = formObj.paymentDate;
      }

      if (formObj.hasOwnProperty("upiOption")) {
        obj.upiTypeId = formObj.upiOption.id;
      }

      paymentInfoList.push(obj);
    }

    paymentInfoListObj.isAdvanceConsume = isAdvanceConsume;

    if (consumeAdvance === "") {
      paymentInfoListObj.consumeAdvance = 0;
    } else if (consumeAdvance !== "") {
      paymentInfoListObj.consumeAdvance = consumeAdvance;
    }

    paymentInfoListObj.paymentInfoList = paymentInfoList;

    //The below variable's value is sent to the postObj.
    let concessionAuthorisedById = 0;

    let totaSumOfAmountFields = calculateFieldAmountSum();

    if (
      netPayableAmountVal > totaSumOfAmountFields &&
      authorityDropdown === true
    ) {
      let concessionAuthorisedObj = getValues("concessionAuthority");

      concessionAuthorisedById = concessionAuthorisedObj.id;
    }

    let isSettledFlagVal = true;

    if (concessionAuthorisedById !== 0) {
      isSettledFlagVal = false;
    }

    let companyIdValue = props.companyId;

    let patientAdvanceIdValue = 0;

    if (props.selectedPatient.AdvanceID) {
      patientAdvanceIdValue = props.selectedPatient.AdvanceID;
    }

    props.submitPaymentInfoModal(
      paymentInfoListObj,
      concessionAuthorisedById,
      isSettledFlagVal,
      companyIdValue,
      patientAdvanceIdValue,
    );
  }

  //function to trigger the validations on the current field ; whose corresponding '+' icon is going to be clicked
  function appendPaymentField(fieldIndex) {
    let requiredObj = cartArr[fieldIndex];

    //if the payment mode is "UPI".
    if (requiredObj.paymentMode && requiredObj.paymentMode.label === "UPI") {
      if (
        (requiredObj.amount || requiredObj.amount === 0) &&
        requiredObj.referenceNumber
      ) {
        let totalAmountVal = calculateFieldAmountSum();

        if (totalAmountVal < computedNetPayable && customCashError === false) {
          let nextFieldAmountVal = computedNetPayable - totalAmountVal;

          append({
            paymentMode: null,
            amount: nextFieldAmountVal,
            referenceNumber: "",
            bankName: null,
            paymentDate: today,
            status: "pending"
          });
        }
      } else {
        trigger();
      }
    }

    //if the payment mode is "CASH"
    if (requiredObj.paymentMode && requiredObj.paymentMode.label === "CASH") {
      if (requiredObj.amount || requiredObj.amount === 0) {
        let totalAmountVal = calculateFieldAmountSum();

        if (totalAmountVal < computedNetPayable && customCashError === false) {
          let nextFieldAmountVal = computedNetPayable - totalAmountVal;

          append({
            paymentMode: null,
            amount: nextFieldAmountVal,
            referenceNumber: "",
            bankName: null,
            paymentDate: today,
            status: "pending"
          });
        }
      } else {
        trigger();
      }
    }

    //if the payment mode is one of "CHEQUE" , "CREDIT CARD" , "ECS" , "DEBIT CARD"
    if (
      requiredObj.paymentMode &&
      (requiredObj.paymentMode.label === "CHEQUE" ||
        requiredObj.paymentMode.label === "CREDIT CARD" ||
        requiredObj.paymentMode.label === "ECS" ||
        requiredObj.paymentMode.label === "ONLINE" ||
        requiredObj.paymentMode.label === "DEBIT CARD")
    ) {
      if (
        (requiredObj.amount || requiredObj.amount === 0) &&
        requiredObj.referenceNumber &&
        requiredObj.bankName &&
        requiredObj.bankName.label !== " "
      ) {
        let totalAmountVal = calculateFieldAmountSum();

        if (totalAmountVal < computedNetPayable && customCashError === false) {
          let nextFieldAmountVal = computedNetPayable - totalAmountVal;

          append({
            paymentMode: null,
            amount: nextFieldAmountVal,
            referenceNumber: "",
            bankName: null,
            paymentDate: today,
            status: "pending"
          });
        }
      } else {
        trigger();
      }
    }

    //if the paymentMode is not selected -- that is when it is undefined ; then at that time also trigger the validation.
    if (!requiredObj.paymentMode) {
      trigger();
    }

    //if the paymentMode is selected as blank ; then at that time also trigger the validation.
    if (requiredObj.paymentMode.label === " ") {
      trigger();
    }
  }

  //function to remove the field whenever the "-" icon is clicked.
  function removePaymentFieldRow(fieldIndex) {
    let totalSumVal = 0;

    for (let index = 0; index < cartArr.length; index++) {
      if (cartArr.length > 1) {
        if (cartArr[index] && cartArr[index].amount) {
          if (index !== fieldIndex) {
            totalSumVal = Number(totalSumVal) + Number(cartArr[index].amount);
          }
        }
      } else if (cartArr.length === 1 && cartArr[index].amount) {
        totalSumVal = Number(cartArr[index].amount);
      }
    }

    remove(fieldIndex);

    let consumeAdvanceFlag = getValues("consumeAdvance");

    //This if block is to detect "Total Amount has exceeded netPayVal".
    if (
      advance !== 0 &&
      (consumeAdvanceFlag === true || consumeAdvanceFlag === "true")
    ) {
      //Here the "requiredBillAmount" means the Total Bill Amount.
      let requiredBillAmount = props.getValues("netPayableAmount");

      let consumeAmountVal = getValues("consumeAmount");

      if (consumeAmountVal === "") {
        consumeAmountVal = 0;
      }

      let tempNetPayVal = requiredBillAmount - consumeAmountVal;

      if (totalSumVal > tempNetPayVal) {
        setNetPayErrorMessage("Total amount exceeded net payable amount");
      } else {
        setNetPayErrorMessage("");
      }
    }

    //This if block is to detect "Total Amount has exceeded netPayVal".
    if (
      advance !== 0 &&
      (consumeAdvanceFlag === false || consumeAdvanceFlag === "false")
    ) {
      //Here the "requiredBillAmount" means the Total Bill Amount.
      let requiredBillAmount = props.getValues("netPayableAmount");

      let tempNetPayVal = requiredBillAmount;

      if (totalSumVal > tempNetPayVal) {
        setNetPayErrorMessage("Total amount exceeded net payable amount");
      } else {
        setNetPayErrorMessage("");
      }
    }

    //This if block is to detect "Total Amount has exceeded netPayVal".
    if (advance === 0) {
      //Here the "requiredBillAmount" means the Total Bill Amount.
      let requiredBillAmount = props.getValues("netPayableAmount");

      let tempNetPayVal = requiredBillAmount;

      if (totalSumVal > tempNetPayVal) {
        setNetPayErrorMessage("Total amount exceeded net payable amount");
      } else {
        setNetPayErrorMessage("");
      }
    }
  }

  //function to detect the number of occurences of "CASH" option.
  //CASH option is allowed only once.
  function detectDuplicateCashOption() {
    let cashOptionCountIndicator = 0;

    for (let cartObj of cartArr) {
      if (cartObj.paymentMode.label === "CASH") {
        cashOptionCountIndicator = cashOptionCountIndicator + 1;
      }
    }

    if (cashOptionCountIndicator > 1) {
      setCustomCashError(true);
    } else {
      setCustomCashError(false);
    }
  }

  //the function which decides when to display the concessionAuthority dropdown.
  // function displayConcessionAuthorityDropdown(sourceOfFunctionCall) {
  //   let totalSumVal = calculateFieldAmountSum();

  //   //if the sum of all the Amount fields in the field array is less than netPayableAmountVal
  //   //then show the concessionAuthority dropdown.
  //   if (totalSumVal < computedNetPayable) {
  //     setAuthorityDropdown(true);
  //   } else {
  //     setAuthorityDropdown(false);
  //     //reset the value of concessionAuthority dropdown
  //     setValue("concessionAuthority", null);
  //     //clear the error of concessionAuthority dropdown.
  //     clearErrors("concessionAuthority");
  //   }
  // }

  //function to correct the last field's Amount input field ;
  //when the Cancel button of the bill settlement confirmation modal is clicked.
  function correctTheLastFieldAmountValue() {
    if (fields.length > 1) {
      //Getting the last index of the field array.
      let lastIndexOfFieldArray = fields.length - 1;

      //calculating the sum of all the amount fields.
      let totalOfFieldAmountsVal = calculateFieldAmountSum();

      //getting the current value of the last field's amount input field.
      let currentLastFieldAmountValue = getValues(
        `paymentCart.[${lastIndexOfFieldArray}].amount`,
      );

      currentLastFieldAmountValue = Number(currentLastFieldAmountValue);

      //The variable sumOfPreviousFieldsExceptLastField contains sum of all the amount input fields except the last field's amount input field.
      let sumOfPreviousFieldsExceptLastField =
        totalOfFieldAmountsVal - currentLastFieldAmountValue;

      //lastIndexAmountVal is the value so that totalOfFieldAmountsVal becomes equal to netPayableAmountVal
      let lastIndexAmountVal =
        netPayableAmountVal - sumOfPreviousFieldsExceptLastField;

      //set the value of last field's amount input field.
      //This is the remaining amount that makes the sum of all the amount fields equal to netPayableAmountVal
      setValue(
        `paymentCart.[${lastIndexOfFieldArray}].amount`,
        lastIndexAmountVal,
      );

      //function to control the display of the concessionAuthority dropdown
      let source =
        "fields.length > 1 if block of correctTheLastFieldAmountValue function.";
      // displayConcessionAuthorityDropdown(source);
    }

    //if there is only one field then patch the netPayable amount val into the
    //amount input field of the first field.
    if (fields.length === 1) {
      // setValue(`paymentCart.[0].amount`, netPayableAmountVal);
      //function to control the display of the concessionAuthority dropdown
      let source =
        "fields.length === 1 if block of correctTheLastFieldAmountValue function.";
      // displayConcessionAuthorityDropdown(source);
    }
  }

  //on change event listener function for the amount input field in the field array.
  function handleAmountChange() {
    //The below if block is to display or hide the "+" icon only at the first field ; when the length of the field is 1.
    if (cartArr.length === 1) {
      let firstFieldAmount = Number(cartArr[0].amount);

      if (firstFieldAmount === netPayableAmountVal) {
        setShowAddIcon(false);
      } else if (firstFieldAmount < netPayableAmountVal) {
        setShowAddIcon(true);
      }
    }

    let totalSumVal = calculateFieldAmountSum();

    let consumeAdvanceFlag = getValues("consumeAdvance");

    //This if block is to detect "Total Amount has exceeded netPayVal".
    if (
      advance !== 0 &&
      (consumeAdvanceFlag === true || consumeAdvanceFlag === "true")
    ) {
      //Here the "requiredBillAmount" means the Total Bill Amount.
      let requiredBillAmount = props.getValues("netPayableAmount");

      let consumeAmountVal = getValues("consumeAmount");

      if (consumeAmountVal === "") {
        consumeAmountVal = 0;
      }

      let tempNetPayVal = requiredBillAmount - consumeAmountVal;

      if (totalSumVal > tempNetPayVal) {
        setNetPayErrorMessage("Total amount exceeded net payable amount");
      } else {
        setNetPayErrorMessage("");
      }
    }

    //This if block is to detect "Total Amount has exceeded netPayVal".
    if (
      advance !== 0 &&
      (consumeAdvanceFlag === false || consumeAdvanceFlag === "false")
    ) {
      //Here the "requiredBillAmount" means the Total Bill Amount.
      let requiredBillAmount = props.getValues("netPayableAmount");

      let tempNetPayVal = requiredBillAmount;

      if (totalSumVal > tempNetPayVal) {
        setNetPayErrorMessage("Total amount exceeded net payable amount");
      } else {
        setNetPayErrorMessage("");
      }
    }

    //This if block is to detect "Total Amount has exceeded netPayVal".
    if (advance === 0) {
      //Here the "requiredBillAmount" means the Total Bill Amount.
      let requiredBillAmount = props.getValues("netPayableAmount");

      let tempNetPayVal = requiredBillAmount;

      if (totalSumVal > tempNetPayVal) {
        setNetPayErrorMessage("Total amount exceeded net payable amount");
      } else {
        setNetPayErrorMessage("");
      }
    }

    //function to control the display of the concessionAuthority dropdown on the change of Amount input field.
    // displayConcessionAuthorityDropdown();
  }

  //change handler to handle the changes in consumeAmount input field
  function handleConsumeAmountChange(consumedAmountNum) {
    // Total bill amount
    const requiredBillAmountVal = Number(
      props.getValues("netPayableAmount")
    );

    // Convert consume amount safely
    const consumeAmt = Number(consumedAmountNum) || 0;

    // Remaining payable amount
    let remainingAmount = requiredBillAmountVal - consumeAmt;

    // Prevent negative value
    if (remainingAmount < 0) {
      remainingAmount = 0;
    }

    remainingAmount = Number(remainingAmount.toFixed(2));

    // Remove all extra payment rows except first
    if (fields.length > 1) {
      remove();
      setShowAddIcon(false);
    }

    // Update first payment row amount
    setValue(`paymentCart.[0].amount`, remainingAmount, {
      shouldValidate: true,
      shouldDirty: true,
    });

    // Clear amount field error
    clearErrors(`paymentCart.[0].amount`);

    // Set payment mode to CASH
    setValue(`paymentCart.[0].paymentMode`, {
      id: 4,
      label: "CASH",
      value: "CASH",
    });

    // Update net payable state
    setNetPayableAmountVal(remainingAmount);

    // Available advance validation
    if (consumeAmt > Number(advance)) {
      setConsumeErrorMsgOne(
        "Note* : Consume Amount Exceeded Available Balance"
      );
    } else {
      setConsumeErrorMsgOne("");
    }

    // Bill amount validation
    if (consumeAmt > requiredBillAmountVal) {
      setConsumeErrorMsgTwo(
        "Note* : Consume Amount Exceeded Bill Amount"
      );
    } else {
      setConsumeErrorMsgTwo("");
    }

    // If fully paid using advance
    if (remainingAmount === 0) {
      setValue(`paymentCart.[0].amount`, 0);
    }
  }

  //Post the opd bill when the condition
  //(netPayableAmountVal === 0 && consumeAdvanceFlag === true) is met.
  function postOpdBillWithNoFieldArray() {
    props.setOpenBackdrop(true);
    closeConfirmationForNoFields();

    let paymentInfoList = [];

    let paymentInfoListObj = {};

    let isAdvanceConsume = getValues("consumeAdvance");
    let consumeAdvance = getValues("consumeAmount");

    paymentInfoListObj.isAdvanceConsume = isAdvanceConsume;

    if (consumeAdvance === "") {
      paymentInfoListObj.consumeAdvance = 0;
    } else if (consumeAdvance !== "") {
      paymentInfoListObj.consumeAdvance = consumeAdvance;
    }

    paymentInfoListObj.paymentInfoList = paymentInfoList;

    //The below variable's value is sent to the postObj.
    let concessionAuthorisedById = 0;

    let isSettledFlagVal = true;

    let companyIdValue = props.companyId;

    let patientAdvanceIdValue = 0;

    if (props.selectedPatient.AdvanceID) {
      patientAdvanceIdValue = props.selectedPatient.AdvanceID;
    }

    props.submitPaymentInfoModal(
      paymentInfoListObj,
      concessionAuthorisedById,
      isSettledFlagVal,
      companyIdValue,
      patientAdvanceIdValue,
    );
  }

  //Post the opd bill when the field array is visible.
  async function postOpdBillWithFieldArray() {
    console.log("checkLog 1");

    // Force form validation and wait for latest state
    const formValid = await trigger();

    let totalOfFieldAmounts = calculateFieldAmountSum();

    if (
      netPayErrorMessage === "" &&
      formValid === true &&
      totalOfFieldAmounts === computedNetPayable &&
      consumeErrorMsgOne === "" &&
      consumeErrorMsgTwo === "" &&
      props?.selectedPatient?.patientCategory === "Self"
    ) {
      console.log("checkLog 2");
      setConfirmationOpen(true);
    } else if (
      props?.selectedPatient?.patientCategory === "Self" &&
      totalOfFieldAmounts !== computedNetPayable
    ) {
      warningAlert("Please check payable amount...!");
    }

    if (
      netPayErrorMessage === "" &&
      formValid === true &&
      totalOfFieldAmounts <= computedNetPayable &&
      consumeErrorMsgOne === "" &&
      consumeErrorMsgTwo === "" &&
      props?.selectedPatient?.patientCategory !== "Self"
    ) {
      console.log("checkLog 3");
      setConfirmationOpen(true);
    } else if (
      props?.selectedPatient?.patientCategory !== "Self" &&
      totalOfFieldAmounts > computedNetPayable
    ) {
      warningAlert("Please select concession authority...!");
    }

    //open the confirmation modal for bill settlement when the below conditions are met.
    // if (
    //   netPayErrorMessage === "" &&
    //   formValid === true &&
    //   totalOfFieldAmounts < computedNetPayable &&
    //   consumeErrorMsgOne === "" &&
    //   consumeErrorMsgTwo === ""
    // ) {
    //   //open the confirmation modal for bill settlement
    //   setBillSettlementConfirmation(true);
    // }

    // open the confirmation modal for saving the bill.
    //when the concessionAuthority dropdown is visible.
    // if (
    //   netPayErrorMessage === "" &&
    //   formValid === true &&
    //   totalOfFieldAmounts <= computedNetPayable &&
    //   consumeErrorMsgOne === "" &&
    //   consumeErrorMsgTwo === ""
    // ) {
    //   //open the cfirmation modal
    //   setConfirmationOpen(true);
    // }
  }

  //event listener function for the change in "Payment Type" dropdown field.
  function paymentModeChangeHandler(e, index) {
    detectDuplicateCashOption();

    if (e.target.value.label === "CHEQUE") {
      setValue(`paymentCart.[${index}].referenceNumber`, "");

      setValue(`paymentCart.[${index}].bankName`, null);
    }

    if (e.target.value.label === "CREDIT CARD") {
      setValue(`paymentCart.[${index}].referenceNumber`, "");

      setValue(`paymentCart.[${index}].bankName`, null);
    }

    if (e.target.value.label === "DEBIT CARD") {
      setValue(`paymentCart.[${index}].referenceNumber`, "");

      setValue(`paymentCart.[${index}].bankName`, null);
    }

    if (e.target.value.label === "ECS") {
      setValue(`paymentCart.[${index}].referenceNumber`, "");

      setValue(`paymentCart.[${index}].bankName`, null);
    }

    if (e.target.value.label === "ONLINE") {
      setValue(`paymentCart.[${index}].referenceNumber`, "");

      setValue(`paymentCart.[${index}].bankName`, null);
    }

    if (e.target.value.label === "UPI") {
      setValue(`paymentCart.[${index}].referenceNumber`, "");

      setValue(`paymentCart.[${index}].bankName`, null);
    }
  }
  function handlePaymentVerification(index, item) {
    console.log("handlePaymentVerificationindex", index, item);

    let statusCode = 2000;


    let vistiId = String(props?.visitId)
    let postObj = {
      transactionAmount: Number(cartArr[index]?.amount)?.toFixed(2),
      // transactionAmount: "1.00",  
      transactionType: item === "CARD" ? String("1") : String("22"),
      additionalAmount: "0.00",
      invoiceNo: vistiId

    }
    console.log("cartArrcartArrcartArrcartArrcartArr", cartArr, "djhfsdjhkjdhsdkfskdfshdjk", postObj);


    props.setOpenBackdrop(true);
    getVerifyCard(postObj)
      .then((response) => response.data)
      .then((res) => {
        let parseData = JSON.parse(res?.result)

        if (res?.statusCode === 200) {
          console.log("getVerifyCardgetVerifyCardge1tVerifyCard", parseData);

          setValue(`paymentCart.[${index}].payment`, parseData?.data?.referenceId)
          setValue(`paymentCart.[${index}].status`, "paid")
          console.log("response of the api", res);
          props?.setOpenBackdrop(false)
          successAlert(res?.message)
        }

      }).catch((error) => {
        setValue(`paymentCart.[${index}].status`, "")
        errorAlert(error?.message)
        props?.setOpenBackdrop(false)

      })





  }

  function handleCheckStatus(index) {
    console.log("handleCheckStatushandleCheckStatus", parseData);
    const referenceID = watch(`paymentCart.[${index}].payment`)
    console.log("referenceIDreferenceIDreferenceIDreferenceID", referenceID);
    getCheckStatus(referenceID)
      .then((response) => response.data)
      .then((res) => {
        console.log("getCheckStatusgetCheckStatus", res);
        if (res?.statusCode === 200) {
          setValue(`paymentCart.[${index}].referenceNumber`, res?.result)
          setValue(`paymentCart.[${index}].status`, "verified")
          // setIsVerified(false)
          successAlert(res?.message)
        } else {
          errorAlert(res?.message)
          setValue(`paymentCart.[${index}].referenceNumber`, "")
        }
      }).catch((error) => {
        errorAlert(error?.message)
        setValue(`paymentCart.[${index}].status`, "")
      })
  }

  function handleConsumeAmountChange(consumedAmountNum) {

    // Total bill amount
    let requiredBillAmountVal = Number(
      props.getValues("netPayableAmount")
    );

    // Remaining payable amount
    let tempNetPayableAmountVal =
      requiredBillAmountVal - Number(consumedAmountNum);

    tempNetPayableAmountVal = Number(
      tempNetPayableAmountVal.toFixed(2)
    );

    // remove extra payment rows
    if (advance !== 0 && consumeAdvanceFlag === true) {
      if (fields.length > 1) {
        remove();
        setShowAddIcon(false);
      }
    }

    // update first payment row amount
    setValue(
      `paymentCart.[0].amount`,
      tempNetPayableAmountVal
    );

    // clear validation errors
    clearErrors(`paymentCart.[0].amount`);

    // set payment mode as CASH
    setValue(`paymentCart.[0].paymentMode`, {
      id: 4,
      label: "CASH",
      value: "CASH",
    });

    // update net payable amount state
    if (tempNetPayableAmountVal <= 0) {
      setNetPayableAmountVal(0);
    } else {
      setNetPayableAmountVal(tempNetPayableAmountVal);
    }

    // validation for advance balance
    if (Number(consumedAmountNum) > Number(advance)) {
      setConsumeErrorMsgOne(
        "Note* : Consume Amount Exceeded Available Balance"
      );
    } else {
      setConsumeErrorMsgOne("");
    }

    // validation for bill amount
    if (
      Number(consumedAmountNum) > requiredBillAmountVal ||
      tempNetPayableAmountVal < 0
    ) {
      setConsumeErrorMsgTwo(
        "Note* : Consume Amount Exceeded Bill Amount"
      );
    } else {
      setConsumeErrorMsgTwo("");
    }
  }
  console.log("sadlkjsldjkdjlsjdjfsdfs", errors);

  console.log("transactionTypetransactionTypetransactionType+", transactionType, selectedIndex);

  console.log("authorityDropdown", authorityDropdown);



  return (
    <>
      <div className="bg-white px-6">
        <Modal
          open={props.open}
          // onClose={() => {
          //   props.closePaymentModal();
          // }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={ModalStyle}>
            <div className="grid grid-cols-1 md:grid-cols-1  w-full">
              <CancelPresentationIconButton
                onClick={() => {
                  props.closePaymentModal();
                  renderCount = 0;
                }}
                style={{
                  paddingLeft: 10,
                }}
              />
            </div>
            <div className="row">
              <fieldset className="border border-gray-300 text-left  lg:mx-auto lg:px-4 md:ml-0 md:mr-0  rounded   lg:m-2 ">
                <legend className="md:mx-2 md:px-2 lg:px-2 font-bold text-gray-700">
                  Bill Information
                </legend>
                <form
                  onSubmit={onSubmitDataHandler}
                  // onSubmit={handleSubmit((data) => {
                  // })}
                  className="grid grid-cols-1 md:grid-cols-1  gap-2"
                >
                  <div className=" bg-white px-2 ">
                    <>
                      {/* Paitent Inf0 */}
                      <fieldset className="mx-auto border w-full rounded my-3 bg-gray-100">
                        <legend className="ml-6 my-2 rounded-xl">
                          <p className="md:mx-2 md:px-2 lg:px-2 font-bold text-gray-700">
                            Patient Information
                          </p>
                        </legend>
                        <div className="md:grid md:grid-cols-[49.25%_1.5%_49.25%] lg:grid lg:grid-cols-[10.5%_1.5%_14%_10.5%_1.5%_14%_10.5%_1.5%_14%_10.5%_1.5%_14%] text-sm px-4 py-0.5">
                          <div className="font-semibold pt-2">Patient Name</div>
                          <div className="pt-2">:</div>
                          <div className="text-gray-700 font-normal pt-2">
                            {props.selectedPatient &&
                              props.selectedPatient.patientName}
                          </div>

                          <div className="font-semibold pt-2">Gender</div>
                          <div className="pt-2">:</div>
                          <div className="text-gray-700 font-normal pt-2">
                            {props.selectedPatient &&
                              props.selectedPatient.gender}
                          </div>

                          <div className="font-semibold pt-2">Age</div>
                          <div className="pt-2">:</div>
                          <div className="text-gray-700 font-normal pt-2">
                            {props.selectedPatient &&
                              props.selectedPatient.ageYear}
                          </div>

                          <div className="font-semibold pt-2">
                            Patient Source
                          </div>
                          <div className="pt-2">:</div>
                          <div className="text-gray-700 font-normal pt-2">
                            {props.selectedPatient &&
                              props.selectedPatient.patientSource}
                          </div>

                          <div className="font-semibold pt-2">
                            Patient Category
                          </div>
                          <div className="pt-2">:</div>
                          <div className="text-gray-700 font-normal pt-2">
                            {props.selectedPatient &&
                              props.selectedPatient.patientCategory}
                          </div>

                          <div className="font-semibold pt-2">Tariff</div>
                          <div className="pt-2">:</div>
                          <div className="text-gray-700 font-normal pt-2">
                            {props.selectedPatient &&
                              props.selectedPatient.tariff}
                          </div>

                          {props.selectedPatient &&
                            props.selectedPatient.patientCategory ===
                            "Self" ? null : (
                            <>
                              <div className="font-semibold pt-2">Company</div>
                              <div className="pt-2">:</div>
                              <div className="text-gray-700 font-normal pt-2">
                                {props.selectedPatient &&
                                  props.selectedPatient.company}
                              </div>
                            </>
                          )}

                          <div className="font-semibold pt-2">Doctor</div>
                          <div className="pt-2">:</div>
                          <div className="text-gray-700 font-normal pt-2">
                            {props.selectedPatient &&
                              props.selectedPatient.doctorName}
                          </div>
                        </div>
                      </fieldset>

                      {/* Advance Information */}
                      {/* Different ui are shown depending on the availability of 
                       Value of patient advance */}
                      {props.selectedPatient &&
                        props?.selectedPatient?.patientAdvance ? (
                        <fieldset className="mx-auto border w-full rounded my-3 bg-gray-100">
                          <legend className="ml-2 rounded-xl">
                            <p className="md:mx-2 md:px-2 lg:font-bold text-gray-700">
                              Patient Bill Information
                            </p>
                          </legend>

                          <div className="md:grid md:grid-cols-[49.25%_1.5%_49.25%] lg:grid lg:grid-cols-[12%_0.9%_13%_14.75%_0.9%_14%_8%_0.9%_10%_13.0%_0.9%_10.65%]  text-sm  py-0.5 px-4 items-center">
                            <div className="font-semibold pt-2 whitespace-nowrap">
                              Advance Available
                            </div>
                            <div className="font-semibold pt-2">:</div>
                            <div className="font-semibold pt-2">
                              ₹&nbsp;
                              {props.selectedPatient &&
                                props?.selectedPatient?.patientAdvance === null
                                ? "0"
                                : props.selectedPatient &&
                                props?.selectedPatient?.patientAdvance}
                            </div>

                            <div className="pt-2 flex items-center gap-2">
                              <div className="">
                                <input
                                  type="checkbox"
                                  id="consumeAdvance"
                                  name="consumeAdvance"
                                  {...register("consumeAdvance")}
                                  onChange={(e) => {
                                    const checked = e.target.checked;

                                    // update flag
                                    setConsumedAdvanceFlag(checked);

                                    // clear errors always when toggling
                                    setConsumeErrorMsgOne("");
                                    setConsumeErrorMsgTwo("");

                                    // =========================
                                    // IMPORTANT FIX
                                    // =========================
                                    if (!checked) {
                                      // reset consume amount immediately
                                      setValue("consumeAmount", 0);
                                      clearErrors("consumeAmount");

                                      // optional but SAFE: reset payment impact immediately
                                      const bill = Number(props.getValues("netPayableAmount")) || 0;

                                      setValue(`paymentCart.[0].amount`, bill);
                                      setValue(`paymentCart.[0].paymentMode`, {
                                        id: 4,
                                        label: "CASH",
                                        value: "CASH",
                                      });

                                      setNetPayableAmountVal(bill);
                                    }
                                  }}
                                />
                              </div>

                              <div className="font-semibold whitespace-nowrap">
                                Consume Advance
                              </div>
                            </div>

                            <div className="flex items-center gap-2 pt-2">
                              <div className="font-semibold">:</div>
                            </div>

                            <div className="flex items-center">
                              {/* {consumeAdvanceFlag === true ? ( */}
                              <>
                                <InputField
                                  control={control}
                                  name="consumeAmount"
                                  disabled={true}
                                  label="Consume Amount"
                                  type="number"
                                  onWheel={(e) => { }}
                                  error={errors.consumeAmount}
                                  inputRef={{
                                    ...register(`consumeAmount`, {
                                      onChange: (e) => {
                                        const value = e.target.value;

                                        if (value === "") {
                                          handleConsumeAmountChange(0);
                                        } else {
                                          handleConsumeAmountChange(Number(value));
                                        }
                                      },
                                    }),
                                  }}
                                />
                              </>
                              {/* ) : null} */}
                            </div>

                            <div className="font-semibold pt-2 whitespace-nowrap lg:mx-2">
                              Bill Amount
                            </div>
                            <div className="font-semibold pt-2 ">:</div>
                            <div className="font-semibold pt-2 ">
                              ₹ {props.getValues("netPayableAmount")}
                            </div>

                            <div className="font-semibold pt-2 whitespace-nowrap">
                              Net Payable Amount
                            </div>
                            <div className="font-semibold pt-2 ">:</div>
                            <div className="font-semibold pt-2 ">
                              ₹ {computedNetPayable}
                            </div>
                          </div>
                        </fieldset>
                      ) : (
                        <fieldset className="mx-auto border w-full rounded my-3 bg-gray-100 px-4">
                          <legend className="ml-2 rounded-xl">
                            <p className="md:mx-2 md:px-2 lg:font-bold text-gray-700">
                              Patient Bill Information
                            </p>
                          </legend>

                          <div className="md:grid md:grid-cols-[49.25%_1.5%_49.25%] lg:grid lg:grid-cols-[12%_0.9%_13%_10.5%_0.9%_14.5%_13.5%_1.5%_14%_10.5%_1.5%_14%]  text-sm  py-0.5 items-center">
                            <div className="font-semibold pt-2 whitespace-nowrap">
                              Advance Available
                            </div>
                            <div className="font-semibold pt-2">:</div>
                            <div className="font-semibold pt-2">
                              ₹&nbsp;
                              {props.selectedPatient &&
                                props?.selectedPatient?.patientAdvance === null
                                ? "0"
                                : props?.selectedPatient &&
                                props?.selectedPatient?.patientAdvance}
                            </div>

                            <div className="font-semibold pt-2">
                              Bill Amount
                            </div>
                            <div className="font-semibold pt-2">:</div>
                            <div className="font-semibold pt-2">
                              ₹ {props.getValues("netPayableAmount")}
                            </div>

                            <div className="font-semibold pt-2 whitespace-nowrap">
                              Net Payable Amount
                            </div>
                            <div className="font-semibold pt-2">:</div>
                            <div className="font-semibold pt-2">
                              ₹ {netPayableAmountVal}
                            </div>
                          </div>
                        </fieldset>
                      )}

                      <div>
                        {consumeErrorMsgOne !== "" ? (
                          <span className="text-red-500 flex">
                            {consumeErrorMsgOne}
                          </span>
                        ) : null}
                      </div>

                      <div>
                        {consumeErrorMsgTwo !== "" ? (
                          <span className="text-red-500 flex">
                            {consumeErrorMsgTwo}
                          </span>
                        ) : null}
                      </div>

                      {/* The paymentFieldArray , Save , Cancel buttons are different depending on the value of   
                      netPayableAmountVal.  */}
                      {computedNetPayable === 0 ||
                        computedNetPayable < 0 ||
                        (consumeAdvanceFlag === true &&
                          (consumeErrorMsgOne !== "" ||
                            consumeErrorMsgTwo !== "")) ||
                        (consumeAdvanceFlag === true &&
                          consumeErrorMsgOne !== "" &&
                          consumeErrorMsgTwo !== "") ? (
                        <Grid
                          item
                          lg={1.5}
                          md={1.5}
                          className="flex justify-end gap-2 py-2"
                        >
                          <CommonButton
                            label="Cancel"
                            className="border border-customRed text-customRed"
                            onClick={() => {
                              props.closePaymentModal();
                              renderCount = 0;
                            }}
                          />

                          <CommonButton
                            label="Save"
                            className="bg-customGreen text-white"
                            onClick={() => {
                              if (
                                netPayErrorMessage === "" &&
                                consumeErrorMsgOne === "" &&
                                consumeErrorMsgTwo === ""
                              ) {
                                let paymentDateMatchingResult =
                                  validatePaymentDate();
                                console.log("paymentDateMatchingResult", paymentDateMatchingResult);

                                if (paymentDateMatchingResult === true) {
                                  setOpenConfirmationForNoFields(true);
                                } else if (
                                  paymentDateMatchingResult === false
                                ) {
                                  errorAlert("Please enter today's date");
                                }
                              }
                            }}
                          />
                        </Grid>
                      ) : (
                        <div className="w-full">
                          <fieldset className="mx-auto border w-full rounded my-3">
                            <legend className="ml-6 my-2 rounded-xl">
                              <p className="md:mx-2 md:px-2 lg:px-2 font-bold text-gray-700">
                                Payment Details :-
                                <span className=" text-red-500">
                                  {netPayErrorMessage}
                                </span>
                              </p>
                            </legend>

                            <div className="mx-auto px-6 py-2">
                              {fields.map((field, index) => {
                                let dropdownObj = watch(`paymentCart.[${index}].paymentMode`);
                                const status = watch(`paymentCart.[${index}].status`) || "pending";
                                console.log("statusstatusstatusstatus", status);

                                return (
                                  <Grid
                                    container
                                    spacing={2}
                                    alignItems="center"
                                    key={field.id}
                                    sx={{ marginY: "0.5rem" }}
                                  >
                                    <>
                                      <Grid item lg={1.5} md={3} sm={6}>
                                        <DropdownField
                                          control={control}
                                          name={`paymentCart.[${index}].paymentMode`}
                                          error={
                                            cartArr[index].paymentMode?.label === "CASH" &&
                                              customCashError === true
                                              ? { message: "Cash Allowed only once." }
                                              : errors.paymentCart?.[index]?.paymentMode
                                          }
                                          label="Payment Type"
                                          dataArray={paymentModeList}
                                          isSearchable={false}
                                          placeholder="Payment Type *"
                                          inputRef={{
                                            ...register(`paymentCart.[${index}].paymentMode`, {
                                              onChange: (e) => {
                                                paymentModeChangeHandler(e, index);
                                              },
                                            }),
                                          }}
                                        />
                                      </Grid>

                                      {dropdownObj?.label === "UPI" && (
                                        <Grid item lg={2.5} md={3} sm={6}>
                                          <DropdownField
                                            control={control}
                                            name={`paymentCart.[${index}].upiOption`}
                                            label="Select UPI Option"
                                            dataArray={upiOptionsList}
                                            isSearchable={false}
                                            isClearable={false}
                                            placeholder="Select UPI Option"
                                            error={errors.paymentCart?.[index]?.upiOption}
                                            searchIcon={false}
                                          />
                                        </Grid>
                                      )}

                                      <Grid item lg={2} md={3} sm={6}>
                                        <InputField
                                          name={`paymentCart.[${index}].amount`}
                                          error={errors.paymentCart?.[index]?.amount}
                                          variant="outlined"
                                          label="Amount"
                                          control={control}
                                          type="number"
                                          onWheel={(e) => e.target.blur()}
                                          inputRef={{
                                            ...register(`paymentCart.[${index}].amount`, {
                                              onChange: (e) => {
                                                let value = parseFloat(e.target.value || 0);
                                                // round to 2 decimal places
                                                value = Number(value.toFixed(2));
                                                setValue(`paymentCart.[${index}].amount`, value);
                                                handleAmountChange()
                                              }
                                            }),
                                          }}
                                        />
                                      </Grid>

                                      {(dropdownObj &&
                                        [
                                          "DEBIT CARD",
                                          "CREDIT CARD",
                                          "ECS",
                                          "ONLINE",
                                          "CHEQUE",
                                          "UPI",
                                        ].includes(dropdownObj.label)) && (
                                          <Grid item lg={2} md={3} sm={6}>
                                            <InputField
                                              name={`paymentCart.[${index}].referenceNumber`}
                                              variant="outlined"
                                              label="Reference Number"
                                              control={control}
                                              error={
                                                errors.paymentCart?.[index]?.referenceNumber
                                              }
                                              onWheel={(e) => e.target.blur()}
                                            />
                                          </Grid>
                                        )}

                                      {(dropdownObj &&
                                        [
                                          "DEBIT CARD",
                                          "CREDIT CARD",
                                          "ECS",
                                          "ONLINE",
                                          "CHEQUE",
                                        ].includes(dropdownObj.label)) && (
                                          <>
                                            <Grid item lg={2.5} md={3} sm={6}>
                                              <DropdownField
                                                control={control}
                                                name={`paymentCart.[${index}].bankName`}
                                                label="Bank Name"
                                                dataArray={bankList}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="Bank Name *"
                                                error={errors.paymentCart?.[index]?.bankName}
                                                searchIcon={true}
                                              />
                                            </Grid>

                                            <Grid item lg={2} md={3} sm={6}>
                                              <DatePickerFieldNew
                                                name={`paymentCart.[${index}].paymentDate`}
                                                control={control}
                                                label="Registration Date"
                                                value={new Date()}
                                                onChange={(newValue) => {
                                                  setValue(
                                                    `paymentCart.[${index}].paymentDate`,
                                                    newValue,
                                                  );
                                                }}
                                                inputFormat="dd-MM-yyyy"
                                                disablePast={true}
                                                disableFuture={true}
                                              />
                                            </Grid>
                                          </>
                                        )}

                                      {/* ✅ COMBINED ICON ROW */}
                                      <Grid
                                        item
                                        lg={2}
                                        md={3}
                                        sm={6}
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                        }}
                                      >
                                        {/* Payment Icon */}
                                        {dropdownObj && ["DEBIT CARD",
                                          "CREDIT CARD", "ECS"].includes(dropdownObj?.label) && (
                                            <div className="flex gap-2">
                                              <Tooltip title="Payment">
                                                <IconButton
                                                  onClick={() => {
                                                    setOpenStartTransactionModal(true)
                                                    setSelectedIndex(index)

                                                  }}
                                                  sx={{
                                                    padding: 0.4,
                                                    cursor: "pointer",
                                                    color: "#2b3289",
                                                    border: 1,
                                                    borderRadius: 1,
                                                  }}
                                                  disabled={status === "paid" || status === "verified"}
                                                >
                                                  <PaymentIcon />
                                                </IconButton>
                                              </Tooltip>
                                              {status !== "pending" && <Tooltip title="Verify">
                                                <IconButton
                                                  onClick={() => {
                                                    handleCheckStatus(index)

                                                  }}
                                                  disabled={status === "success "}
                                                  sx={{
                                                    padding: 0.4,
                                                    cursor: "pointer",
                                                    color: "#118122",
                                                    border: 1,
                                                    borderRadius: 1,
                                                  }}
                                                  disabled={status === "verified"}
                                                >
                                                  <CheckCircleIcon />
                                                </IconButton>
                                              </Tooltip>}
                                              <Tooltip title="Cancel Transaction">
                                                <IconButton
                                                  onClick={() => {
                                                    update(index, {
                                                      ...fields[index],
                                                      status: "pending"
                                                    })

                                                  }}
                                                  sx={{
                                                    padding: 0.4,
                                                    cursor: "pointer",
                                                    color: "red",
                                                    border: 1,
                                                    borderRadius: 1,
                                                  }}><CancelIcon /></IconButton>
                                              </Tooltip>
                                            </div>
                                          )}


                                        {/* Add Icon (first row) */}
                                        {showAddIcon === true && index === 0 && (
                                          <AddOutlinedIcon
                                            className="rounded-full border-2 border-cyan-600 cursor-pointer"
                                            onClick={() => {
                                              if (netPayErrorMessage === "") {
                                                appendPaymentField(index);
                                              }
                                            }}
                                          />
                                        )}

                                        {/* Remove + Add (other rows) */}
                                        {index > 0 && fields.length > 1 && (
                                          <>
                                            <RemoveOutlinedIcon
                                              className="rounded-full border-2 border-red-600 cursor-pointer"
                                              onClick={() => {
                                                if (fields.length > 1) {
                                                  removePaymentFieldRow(index);
                                                }
                                              }}
                                            />
                                            <AddOutlinedIcon
                                              className="rounded-full border-2 border-cyan-600 cursor-pointer"
                                              onClick={() => {
                                                if (netPayErrorMessage === "") {
                                                  appendPaymentField(index);
                                                }
                                              }}
                                            />
                                          </>
                                        )}
                                      </Grid>
                                    </>
                                  </Grid>
                                );
                              })}

                              <Grid container spacing={2}>
                                <Grid item lg={2.5} md={6} sm={6}>
                                  <InputField
                                    control={control}
                                    name="remarks"
                                    label="Remarks"
                                  />
                                </Grid>
                              </Grid>
                            </div>

                            {authorityDropdown && (
                              <div className="mx-auto px-6 py-2 whitespace-nowrap">
                                <Grid container spacing={2}>
                                  <Grid item lg={2.5} md={6} sm={6}>
                                    {displayCreditAuthorityLabel && (
                                      <p className="text-red-700">
                                        Select Credit Authority
                                      </p>
                                    )}
                                    <DropdownField
                                      control={control}
                                      name="concessionAuthority"
                                      label="Concession Authority"
                                      dataArray={concessionAuthorityArray}
                                      placeholder="Concession Authority"
                                      error={errors.concessionAuthority}
                                      isSearchable={false}
                                      inputRef={{
                                        ...register("concessionAuthority", {
                                          onChange: (e) => {
                                            let obj = e.target.value;
                                            if (obj && obj.id !== 1) {
                                              setDisplayCreditAuthorityLabel(false);
                                            }
                                          },
                                        }),
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              </div>
                            )}
                          </fieldset>

                          <Grid
                            item
                            lg={1.5}
                            md={1.5}
                            className="flex justify-end gap-2 py-2"
                          >
                            {renderNonTabularButtons()}
                          </Grid>
                        </div>
                      )}
                    </>
                  </div>
                </form>
              </fieldset>
            </div>
          </Box>
        </Modal>
      </div>

      {/* backdrop */}
      <CommonBackDrop openBackdrop={props.openBackdrop} />

      <ConfirmationModal
        confirmationOpen={confirmationOpen}
        confirmationHandleClose={confirmationHandleClose}
        confirmationSubmitFunc={() => {
          handleSubmit(onSubmitDataHandler)();
        }}
        confirmationLabel="Confirmation "
        confirmationMsg="Save Payment Details?"
        confirmationButtonMsg="Save Payment"
      />

      {/* ConfirmationModal when there are no fieldArrays displayed on the modal. */}
      <ConfirmationModal
        confirmationOpen={openConfirmationForNoFields}
        confirmationHandleClose={closeConfirmationForNoFields}
        confirmationSubmitFunc={() => {
          postOpdBillWithNoFieldArray();
        }}
        confirmationLabel="Confirmation "
        confirmationMsg="Save Payment Details?"
        confirmationButtonMsg="Save Payment"
      />

      <ConfirmationModal
        confirmationOpen={billSettlementConfirmation}
        confirmationHandleClose={() => {
          //event listener for "Cancel" button.
          billSettlementConfirmationClose();
          correctTheLastFieldAmountValue();
        }}
        confirmationSubmitFunc={() => {
          //event listener for "Settle Bill" button.
          //the function which decides when to display the concessionAuthority dropdown.
          // displayConcessionAuthorityDropdown();
          billSettlementConfirmationClose();
        }}
        confirmationLabel="Confirmation "
        confirmationMsg="Do You Want To Settle This Bill ?"
        confirmationButtonMsg="Settle Bill"
      />

      {consumeAdvanceFlag && <AdvanceConsumeDetails billAmount={props.getValues("netPayableAmount")} setNetPayableAmountVal={setNetPayableAmountVal} getValues={getValues} setValue={setValue} setConsumedAdvanceFlag={setConsumedAdvanceFlag} open={consumeAdvanceFlag} handleClose={handleCloseAdavnceConsumeModal} consumeAdvaceData={props?.consumeAdvaceData} setConsumeAdvanceData={props?.setConsumeAdvanceData} handleConsumeAmountChange={handleConsumeAmountChange}
      />}

      <Modal
        open={openStartTransactionModal}
        aria-labelledby="modal-modal-title"
      >
        <Box sx={ModalStyleTransactionType}>
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold whitespace-nowrap">
              Select Transaction Type
            </h2>

            <CancelPresentationIconButton
              onClick={() => setOpenStartTransactionModal(false)}
            />
          </div>

          <div className="grid grid-cols-2 gap-5">
            <Button
              variant="outlined"
              fullWidth
              sx={{
                py: 1,
                borderRadius: 2,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                fontSize: "16px",
                fontWeight: 600,
                textTransform: "none",
                transition: "all 0.2s ease",

                "&:hover": {
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  borderColor: "#1976d2",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
                },
              }}
              onClick={() => {
                handlePaymentVerification(selectedIndex, "CARD")
                setOpenStartTransactionModal(false)
              }}
            >
              <PaymentIcon />
              <span>CARD</span>
            </Button>

            <Button
              variant="outlined"
              fullWidth
              sx={{
                py: 1,
                borderRadius: 2,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                fontSize: "16px",
                fontWeight: 600,
                textTransform: "none",
                transition: "all 0.2s ease",

                "&:hover": {
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  borderColor: "#1976d2",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
                },
              }}
              onClick={() => {
                handlePaymentVerification(selectedIndex, "QR")
                setOpenStartTransactionModal(false)

              }}
            >
              <QrCodeIcon />
              <span>QR </span>
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
